import { Cell } from "../components/Cell";
import { COLUMN_BY_KEY, FOLLOW_UP_GROUPS } from "../model/materielConstants";
import { formatFollowUpPatient } from "../model/followUpRules";
import {
    inactivePatientBadgeStyle,
    patientIdentityFieldStyle,
    verticalDetailStyle,
    verticalFieldLabelStyle,
    verticalFieldStyle,
    verticalGroupFieldsStyle,
    verticalGroupSectionStyle,
    verticalGroupTitleStyle,
    verticalPatientButtonStyle,
    verticalPatientListScrollStyle,
    verticalSectionsStyle,
    verticalSidebarStyle,
    verticalSidebarTitleStyle,
    verticalWorkspaceStyle,
} from "../styles/materielStyles";

// Format vertical : liste des patients à gauche, fiche groupée du patient sélectionné à droite.
export function FollowUpVerticalView({ rows, selectedRow, onSelect, onEditPatient, onPatch }) {
    if (!selectedRow) return null;

    return (
        <>
            <style>{`
                @media (max-width: 900px) {
                    .medical-equipment-vertical {
                        grid-template-columns: 1fr !important;
                    }
                    .medical-equipment-patient-list {
                        position: static !important;
                        max-height: 220px !important;
                    }
                }
            `}</style>
            <div className="medical-equipment-vertical" style={verticalWorkspaceStyle}>
                <aside className="medical-equipment-patient-list" style={verticalSidebarStyle}>
                    <div style={verticalSidebarTitleStyle}>Patients</div>
                    <div style={verticalPatientListScrollStyle}>
                        {rows.map(row => {
                            const selected = row.id === selectedRow.id;
                            return (
                                <button
                                    key={row.id}
                                    type="button"
                                    onClick={() => onSelect(row)}
                                    style={verticalPatientButtonStyle(row, selected)}
                                >
                                    <strong style={{ display: "block" }}>{formatFollowUpPatient(row) || "Patient à renseigner"}</strong>
                                    <small style={{ display: "block", marginTop: "3px", color: "#64748b" }}>{row.equipmentType || "Matériel non renseigné"}</small>
                                    {row.inactive && <small style={inactivePatientBadgeStyle}>Patient inactif</small>}
                                </button>
                            );
                        })}
                    </div>
                </aside>
                <main style={verticalDetailStyle}>
                    <section style={verticalGroupSectionStyle(FOLLOW_UP_GROUPS[0])}>
                        <h3 style={verticalGroupTitleStyle(FOLLOW_UP_GROUPS[0])}>Patient</h3>
                        <div style={verticalGroupFieldsStyle}>
                            <div style={verticalFieldStyle}>
                                <span style={verticalFieldLabelStyle}>Nom et prénom</span>
                                <button type="button" onClick={() => onEditPatient(selectedRow)} title="Modifier le patient" style={patientIdentityFieldStyle}>
                                    <span>
                                        <strong style={{ display: "block" }}>{formatFollowUpPatient(selectedRow) || "Patient à renseigner"}</strong>
                                        {selectedRow.inactive && <small style={inactivePatientBadgeStyle}>Patient inactif</small>}
                                    </span>
                                    <span aria-hidden="true">✎</span>
                                </button>
                            </div>
                            {["cltPharmacie", "equipmentType"].map(columnKey => {
                                const column = COLUMN_BY_KEY[columnKey];
                                return (
                                    <label key={column.key} style={verticalFieldStyle}>
                                        <span style={verticalFieldLabelStyle}>{column.label}</span>
                                        <Cell
                                            row={selectedRow}
                                            column={column}
                                            onChange={value => onPatch(selectedRow, { [column.key]: value })}
                                        />
                                    </label>
                                );
                            })}
                        </div>
                    </section>
                    <FollowUpGroupedFields
                        row={selectedRow}
                        onPatch={patch => onPatch(selectedRow, patch)}
                        excludedGroups={["patient"]}
                    />
                </main>
            </div>
        </>
    );
}

export function FollowUpGroupedFields({ row, onPatch, excludedGroups = [] }) {
    return (
        <div style={verticalSectionsStyle}>
            {FOLLOW_UP_GROUPS.filter(group => !excludedGroups.includes(group.key)).map(group => {
                const columns = group.columns
                    .filter(columnKey => columnKey !== "patient")
                    .map(columnKey => COLUMN_BY_KEY[columnKey]);
                return (
                    <section key={group.key} style={verticalGroupSectionStyle(group)}>
                        <h3 style={verticalGroupTitleStyle(group)}>{group.label}</h3>
                        <div style={verticalGroupFieldsStyle}>
                            {columns.map(column => (
                                <label key={column.key} style={verticalFieldStyle}>
                                    <span style={verticalFieldLabelStyle}>{column.label}</span>
                                    <Cell
                                        row={row}
                                        column={column}
                                        onChange={value => onPatch(
                                            value && typeof value === "object" ? value : { [column.key]: value }
                                        )}
                                    />
                                </label>
                            ))}
                        </div>
                    </section>
                );
            })}
        </div>
    );
}
